import clsx from 'clsx'

/** Tailwind-friendly class merger. Thin wrapper so we can swap libraries later. */
export const cn = (...args) => clsx(...args)
